import React, { useRef, useEffect } from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa'; // Using Plus/Minus for a minimal look

const FaqItem = ({ faq, index, isOpen, toggleFaq }) => {
  const contentRef = useRef(null);

  // This effect will handle the smooth height animation
  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.style.maxHeight = isOpen ? `${contentRef.current.scrollHeight}px` : '0px';
    }
  }, [isOpen]);

  return (
    // The main container for each FAQ item
    <div className={`faq-item ${isOpen ? 'is-open' : ''}`}>
      <button
        className="faq-question-btn"
        onClick={() => toggleFaq(index)}
        aria-expanded={isOpen}
      >
        <span className="faq-question-text">{faq.question}</span>
        {/* The toggle icon will now be a simple, elegant plus/minus */}
        <div className="faq-toggle-icon-wrapper">
          {isOpen ? <FaMinus className="faq-toggle-icon" /> : <FaPlus className="faq-toggle-icon" />}
        </div>
      </button>

      {/* The container for the answer, which expands/collapses */}
      <div ref={contentRef} className="faq-answer-content">
        <div className="faq-answer-text">
          {faq.answer}
        </div>
      </div>
    </div>
  );
};

export default FaqItem;